import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Input, Button, message, Divider, Popconfirm, notification, Select, Row, Col, Space, Modal, InputNumber, Switch } from 'antd'

import Main from '../components/Main'
import {
  CLONE_UPDATE,
  UPDATE_SETTINGS,
  CLONE_INFO,
  CLONE_SAVE,
  CLONE_STOP,
  CLONE_START,
  CLONE_DELETE,
  CLONE_INVOICE_SEND,
  requestToServer
} from '../lib/helper'

import {paymetMethod} from '../config'
import BillingCard from '../components/BillingCard'   // Task007
import LogList from '../components/LogList'   // Task009

/*
const RedeemFree = ({ clientInfo, platformName, updateAllInfo }) => { // not used these time

  const [showModal, setShowModal] = useState(false)
  const [value, setValue] = useState(0)

  return (
    <div>
      <div>
        redeemFree : { clientInfo && clientInfo.store && clientInfo.store.redeemFree} <Button size='small' onClick={()=>setShowModal(true)}>set</Button>
      </div>
      <Modal
        title='Establecer el valor de redeemFree (canjes gratis)'
        visible={showModal}
        onCancel={ () => setShowModal(false) }
        onOk = { () => {
          requestToServer({platformName, key: 'redeemFree', value} , UPDATE_SETTINGS).then( r => {
            requestToServer({platformName}, CLIENT_UPDATE).then(r => {
              updateAllInfo()
              setShowModal(false)
              setValue(0)
            })
          } )
        }}
      >
        <InputNumber value={value} onChange={setValue} />
      </Modal>
    </div>
  )
}
*/

const RedeemBought = ({ clientInfo, platformName, updateAllInfo, isMultiStore, refreshLog }) => {

  const [showModal, setShowModal] = useState(false)
  const [value, setValue] = useState(0)
  const [sendEmail, setSendEmail] = useState(true)

  let currentRedeems = 0
  if ( isMultiStore ) {
    currentRedeems = clientInfo.client.redeemedsLimit
  } else {
    currentRedeems = clientInfo.store.redeemBought
  }

  return (
    <div>
      <div>
        redeemBought : { currentRedeems} <Button size='small' onClick={()=>setShowModal(true)}>add</Button>
      </div>
      <Modal
        title='Añadir canjes a redeemBought'
        visible={showModal}
        onCancel={ () => setShowModal(false) }
        onOk = { () => {
          let key = 'redeemBought'
          if ( isMultiStore ) {
            key = 'addRedeemBoughtMulti'
          }
          requestToServer({platformName, key, value, sendEmail} , UPDATE_SETTINGS).then( r => {
            requestToServer({platformName}, CLONE_UPDATE).then(r => {
              updateAllInfo()
              refreshLog()   // Task009: la recarga de canjes deja una fila en logs
              setShowModal(false)
              setValue(0)
            }).catch(()=>{})
          } ).catch(()=>{})
        }}
      >
        <div>
          +<InputNumber value={value} onChange={setValue} />
        </div>
        <div style={{paddigTop:'10px'}}>
          <Switch onChange={setSendEmail} checked={sendEmail}/> Enviar email
        </div>

      </Modal>
    </div>
  )
}

// Task008: llave maestra de la tarjeta en Apple / Google Wallet del clon (configurations.enableMobileWallet,
// Task054 D11). Prendida, el comercio ve en su Configuración la casilla para ofrecérsela a sus clientes; Pulpo
// no toca esa casilla. Sin credenciales en el clon no se puede prender (apagar sí).
const WalletSwitch = ({ wallet, platformName, updateAllInfo, refreshLog }) => {

  const [saving, setSaving] = useState(false)

  if ( ! wallet || wallet.e ) {
    return <div>Wallet: no se pudo leer el estado</div>
  }

  const toggle = (checked) => {
    setSaving(true)
    requestToServer({platformName, key: 'enableMobileWallet', value: checked}, UPDATE_SETTINGS).then(() => {
      message.info(checked ? 'Wallet activado' : 'Wallet desactivado')
      updateAllInfo()
      refreshLog()   // Task009: walletEnabled / walletDisabled
    }).catch(()=>{})   // el mensaje de error ya lo mostró requestToServer
    .finally(() => setSaving(false))
  }

  return (
    <div style={{paddingTop:'10px'}}>
      <Switch checked={wallet.enabled} loading={saving} onChange={toggle}
        disabled={ ! wallet.enabled && ! wallet.apple && ! wallet.google } /> Tarjeta en Apple / Google Wallet
      <div style={{fontSize:'12px', color:'#888'}}>
        Apple: {wallet.apple ? 'sí' : 'no'} · Google: {wallet.google ? 'sí' : 'no'} · Actualización automática: {
          wallet.cron ? 'sí' : 'no (falta cronWalletPassesUpdate en cronEveryFewMinutesFuncs del config.json)' }
      </div>
    </div>
  )
}

// Task010: llave maestra de la segmentación de clientes del clon (configurations.enableCustomerSegments, Task055 D17
// del repo padre). Prendida, el comercio ve en su Configuración la casilla "Segmentación de clientes"; Pulpo no toca
// esa casilla. Sin la migración de Task055 en el clon no se puede prender (apagar sí).
const SegmentsSwitch = ({ segments, store, isMultiStore, platformName, updateAllInfo, refreshLog }) => {

  const [saving, setSaving] = useState(false)

  if ( ! segments || segments.e ) {
    return <div>Segmentación: no se pudo leer el estado</div>
  }

  const toggle = (checked) => {
    setSaving(true)
    requestToServer({platformName, key: 'enableCustomerSegments', value: checked}, UPDATE_SETTINGS).then(() => {
      message.info(checked ? 'Segmentación activada' : 'Segmentación desactivada')
      updateAllInfo()
      refreshLog()   // segmentsEnabled / segmentsDisabled
    }).catch(()=>{})   // el mensaje de error ya lo mostró requestToServer
    .finally(() => setSaving(false))
  }

  return (
    <div style={{paddingTop:'10px'}}>
      <Switch checked={segments.enabled} loading={saving} onChange={toggle}
        disabled={ ! segments.enabled && ! segments.ready } /> Segmentación de clientes
      <div style={{fontSize:'12px', color:'#888'}}>
        { segments.ready ? 'Código de Task055: sí' : 'Código de Task055: no (falta la migración 20261102110000)' } · Recálculo diario: {
          segments.cron ? 'sí' : 'no (falta cronCustomerSegmentsUpdate en cronEveryDayFuncs del config.json)' }
        { /* D5: solo en un comercio; store es la fila del comercio (consulta [3] de /clone/info) */ }
        { ! isMultiStore && segments.ready && store && ! store.e &&
          <> · Casilla del comercio: { store.customerSegmentsActive ? 'marcada' : 'sin marcar' }</> }
      </div>
    </div>
  )
}

/*
const RedeemBoughtMulti =({ clientInfo, platformName, updateAllInfo }) => {

  const [showModal, setShowModal] = useState(false)
  const [value, setValue] = useState(0)

  return (
    <div>
      <div>
        RedeemBought : {clientInfo && clientInfo.client && clientInfo.client.redeemedsLimit} <Button size='small' onClick={()=>setShowModal(true)}>set</Button>
      </div>
      <Modal
        title='Añadir canjes a redeemBought para MultiStore'
        visible={showModal}
        onCancel={ () => setShowModal(false) }
        onOk = { () => {
          requestToServer({platformName, key: 'addRedeemBoughtMulti', value} , UPDATE_SETTINGS).then( r => {
            requestToServer({platformName}, CLIENT_UPDATE).then(r => {
              updateAllInfo()
              setShowModal(false)
              setValue(0)
            })
            
          } )
        }}
      >
        +<InputNumber value={value} onChange={setValue} />
      </Modal>
    </div>
  )
}
*/

// Modal de confirmación para las acciones de pm2 (detener / levantar).
// El texto es opcional y se le manda al cliente del clon por email si el switch está activo;
// vaya o no vaya el email, la acción siempre queda registrada en logs (backend, Task002.md §6).
const PlatformAction = ({ platformName, endpoint, label, title, okText, askNonPayment, onDone }) => {

  const [showModal, setShowModal] = useState(false)
  const [comment, setComment] = useState('')
  const [sendEmail, setSendEmail] = useState(false)
  const [sending, setSending] = useState(false)
  const [forNonPayment, setForNonPayment] = useState(false)   // Task007: solo en Detener

  const run = () => {
    setSending(true)
    requestToServer({platformName, comment, sendEmail, forNonPayment: !!askNonPayment && forNonPayment}, endpoint).then( r => {
      setSending(false)
      setShowModal(false)
      setComment('')
      setForNonPayment(false)
      // /client/start responde el string de resultado; /client/stop responde vacío
      notification.info({ message: r ? r : 'Plataforma detenida' })
      if ( onDone ) { onDone() }   // Task007: refresca la ficha de cobro (el estado pudo pasar a 'suspendido')
    }).catch( () => setSending(false) )   // el mensaje de error ya lo mostró requestToServer
  }

  return (
    <>
      <Button onClick={() => setShowModal(true)}>{label}</Button>
      <Modal
        title={title}
        visible={showModal}
        okText={okText}
        confirmLoading={sending}
        onCancel={() => setShowModal(false)}
        onOk={run}
      >
        <Input.TextArea
          autoSize={{minRows:3}} value={comment}
          placeholder='Mensaje para el cliente (opcional)'
          onChange={e => setComment(e.target.value)}
        />
        <div style={{paddingTop:'10px'}}>
          <Switch onChange={setSendEmail} checked={sendEmail}/> Enviar email al cliente
        </div>
        {/* Task007: marca el cobro del clon como suspendido y arranca la cuenta de los 3 meses */}
        { askNonPayment && <div style={{paddingTop:'10px'}}>
          <Switch onChange={setForNonPayment} checked={forNonPayment}/> Suspensión por falta de pago
        </div> }
      </Modal>
    </>
  )
}

// Envío de la factura al cliente del clon: el PDF viaja en base64 dentro del JSON (§8.2 de
// Task002.md). El límite del parser de esa ruta es 15mb de base64, o sea ~10.9MB de archivo
// real; se corta antes, en 10MB, para dar un mensaje claro en vez del 413 genérico de express.
const MAX_INVOICE_BYTES = 10 * 1024 * 1024

const InvoiceSend = ({ platformName, clientEmail, onSent }) => {

  const [file, setFile] = useState(null)
  const [comment, setComment] = useState('')
  const [sending, setSending] = useState(false)
  // cambiarle la key al <input type='file'> es la única forma de limpiarlo: es no controlado,
  // y sin esto sigue mostrando el archivo anterior después de un envío exitoso
  const [inputKey, setInputKey] = useState(0)

  const pick = (chosen) => {
    if ( chosen && chosen.size > MAX_INVOICE_BYTES ) {
      message.error('El archivo supera los 10MB')
      setInputKey( k => k + 1 )
      setFile(null)
      return
    }
    setFile(chosen)
  }

  const send = () => {
    if ( ! file ) { return }
    setSending(true)
    let reader = new FileReader()
    reader.onload = () => {
      // reader.result viene como "data:application/pdf;base64,XXXX" — el backend quiere sólo XXXX
      let fileBase64 = reader.result.split(',')[1]
      requestToServer({
        platformName, filename: file.name, fileBase64, comment
      }, CLONE_INVOICE_SEND).then(() => {
        message.info('Factura enviada a ' + clientEmail)
        setSending(false)
        setFile(null)
        setComment('')
        setInputKey( k => k + 1 )
        if ( onSent ) { onSent() }   // Task009: invoiceEmailed
      }).catch( () => setSending(false) )   // el mensaje de error ya lo mostró requestToServer
    }
    reader.onerror = () => { message.error('No se pudo leer el archivo'); setSending(false) }
    reader.readAsDataURL(file)
  }

  return (
    <div style={{paddingTop:'15px'}}>
      <Divider />
      <div>Enviar factura</div>
      <input key={inputKey} type='file' accept='application/pdf'
        onChange={e => pick(e.target.files[0])} />
      <Input placeholder='Nota para el cliente (opcional)' value={comment}
        onChange={e => setComment(e.target.value)} />
      <Button
        disabled={ ! file || ! clientEmail || sending }
        loading={sending}
        onClick={send}
      >
        { clientEmail ? 'Enviar factura a ' + clientEmail : 'El clon no tiene email cargado' }
      </Button>
    </div>
  )
}

export default function Clone() {

  const [clientInfo, setClientInfo] = useState(null)
  const [subscriptionId, setSubscriptionId] = useState(null)
  const [paymentType, setPaymentType] = useState(null)
  const [notes, setNotes] = useState('')
  const [clientName, setClientName] = useState('')
  const [clientEmail, setClientEmail] = useState('')
  const [billingKey, setBillingKey] = useState(0)   // Task007: cambiarla vuelve a cargar la ficha de cobro
  // Task009: cambiarla vuelve a cargar el log del clon desde la página 1 (mismo patrón que billingKey)
  const [logKey, setLogKey] = useState(0)
  const refreshLog = () => setLogKey(k => k + 1)

//  const [all, setAll] = useState(null)

  const { platformName } = useParams()

  useEffect(() => {
    updateAllInfo()    
  }, [])


  const updateAllInfo = () => {
    requestToServer({platformName}, CLONE_INFO).then(r => { // should call from db
      setClientInfo(r)
      setSubscriptionId(r.client.subscriptionId)
      setPaymentType(r.client.paymentType)
      setNotes(r.client.notes)
      setClientName(r.client.clientName)
      setClientEmail(r.client.clientEmail)
    }).catch(()=>{})
  }



  return (

    <Main
      pageHeader={{ title: platformName  , back: true }}
    >

    { clientInfo && <div style={{paddingLeft:'10px', paddingRight:'10px', paddingBottom: '10px'}}>



      Tipo: {clientInfo.configPlatform.isMultiStore ? 'MultiStore' : 'OneStore'} <br />


      { clientInfo.configPlatform.isMultiStore ?
        <div>
{/*          <RedeemBoughtMulti clientInfo={clientInfo} platformName={platformName} updateAllInfo={updateAllInfo}/> */}
          <RedeemBought clientInfo={clientInfo} platformName={platformName} updateAllInfo={updateAllInfo} isMultiStore={true} refreshLog={refreshLog} />
          
        </div> : <div>
          Customers : { clientInfo && clientInfo.customers } <br /> 
          <RedeemBought clientInfo={clientInfo} platformName={platformName} updateAllInfo={updateAllInfo} isMultiStore={false} refreshLog={refreshLog} />
        </div>}

      {/* Task008 */}
      <WalletSwitch wallet={clientInfo.wallet} platformName={platformName} updateAllInfo={updateAllInfo} refreshLog={refreshLog} />

      {/* Task010 */}
      <SegmentsSwitch segments={clientInfo.segments} store={clientInfo.store}
        isMultiStore={clientInfo.configPlatform && clientInfo.configPlatform.isMultiStore}
        platformName={platformName} updateAllInfo={updateAllInfo} refreshLog={refreshLog} />


      <Divider />

      <Space>
        <PlatformAction platformName={platformName} endpoint={CLONE_STOP}
          label='Detener' title='Detener la plataforma' okText='Detener'
          askNonPayment onDone={() => { setBillingKey(k => k + 1); refreshLog() }} />   {/* Task009: también recarga el log */}

        <PlatformAction platformName={platformName} endpoint={CLONE_START}
          label='Levantar' title='Levantar la plataforma' okText='Levantar' onDone={refreshLog} />   {/* Task009 */}

        {/* "Eliminar" sigue igual que hoy, sin implementar del lado del backend */}
        <Popconfirm
          title='Seguro de elimiar la plataforma?'
          okText='Eliminar'
          onConfirm={ () => requestToServer({platformName}, CLONE_DELETE).then(r => {
            notification.info({message:r})
          } ).catch(()=>{}) }
        >
          <Button>Eliminar</Button>
        </Popconfirm>


      </Space>

      <Divider />


      <Row>
        <Col span={14}>
          <Input addonBefore='Cliente:' value={clientName} onChange={e=>setClientName(e.target.value)} placeholder='nombre'/>
        </Col>
        <Col span={10}>
          <Input value={clientEmail} onChange={e=>setClientEmail(e.target.value)} placeholder='email'/>
        </Col>
      </Row>

       <Input addonBefore='SubscId:' value={subscriptionId}
        onChange={ e => setSubscriptionId(e.target.value) }
        addonAfter={
          <Select
            placeholder="Método Pago"
            value={paymentType}
            onChange={setPaymentType}
            style={{ width: 210 }}   // Task007: etiquetas más largas (Openpay, dLocal Go, Recurrente)
          >
            { Object.keys(paymetMethod).map( type => {
              return( <Select.Option value={type} key={type}>{paymetMethod[type]}</Select.Option>)
            })}
          </Select>
        }
       />

       <Input.TextArea autoSize={{minRows:2}} value={notes} placeholder='Notas' onChange={e => setNotes(e.target.value) }/>


       <Button
        onClick={ () => requestToServer({
          platformName, subscriptionId, paymentType, notes, clientEmail, clientName
        }, CLONE_SAVE).then(r => {
          message.info('Actualizado')
          setBillingKey(k => k + 1)   // Task007 (Revisión 9): paymentType decide si el cobro es automático
        }).catch(()=>{}) }
       >Guardar</Button>

       {/* Task007: la ficha de cobro va después del formulario del clon y antes de la factura. Está dentro del bloque de
           clientInfo: si la base del clon no responde la página queda vacía (como antes) y el cobro se ve igual desde
           la pantalla Cobros, que lee solo la base de Pulpo */}
       <BillingCard key={billingKey} platformName={platformName} onChanged={refreshLog} />   {/* Task009: onChanged */}

       <InvoiceSend platformName={platformName} clientEmail={clientEmail} onSent={refreshLog} />   {/* Task009: onSent */}

    </div>}

    {/* Task009: log del clon, fuera del bloque de clientInfo: se ve aunque la base del clon no responda */}
    <div style={{paddingLeft:'10px', paddingRight:'10px', paddingBottom: '10px'}}>
      <Divider />
      <div>Log</div>
      <LogList key={logKey} platformName={platformName} showPlatform={false} />
    </div>

    </Main>

  )
}